export default function ContactSection() {
  return (
    <section id="contact" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">取得联系</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">联系我们</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            有任何关于91年国产影片视频的问题或建议，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-10 border border-gray-100">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 rounded-xl bg-white border border-gray-100 hover:border-red-200 transition-all duration-300 cursor-pointer">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-red-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-red-600 text-xl"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900 mb-1">电子邮箱</p>
                <p className="text-xs text-gray-500">contact@91guochan.com</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-white border border-gray-100 hover:border-red-200 transition-all duration-300 cursor-pointer">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-red-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-red-600 text-xl"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900 mb-1">微信公众号</p>
                <p className="text-xs text-gray-500">91年国产影片视频</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-white border border-gray-100 hover:border-red-200 transition-all duration-300 cursor-pointer">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-red-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-feedback-line text-red-600 text-xl"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900 mb-1">意见反馈</p>
                <p className="text-xs text-gray-500">在线提交反馈表</p>
              </div>
            </div>

            <div className="text-center">
              <p className="text-sm text-gray-500 mb-4">
                如需91精品视频在线播放内容推荐或91免费视频网站使用问题，请随时通过以上方式联系我们。我们的运营团队将在24小时内回复您的咨询。
              </p>
              <a
                href="#contact"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-red-600 hover:bg-red-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-send-plane-line"></i>提交反馈
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}